import React from "react"
import Papa from "papaparse"
import Encoding from "encoding-japanese"
import {
  object, string, func, element, oneOfType,
} from "prop-types"

CsvReader.propTypes = {
  accept: string,
  cssClass: string,
  cssInputClass: string,
  fileEncoding: string,
  inputId: string,
  inputStyle: object,
  label: oneOfType([string, element]),
  onError: func,
  onFileLoaded: func.isRequired,
  parserOptions: object,
}

export default function CsvReader({
  accept = `.csv, text/csv`,
  cssClass = `csv-reader-input`,
  cssLabelClass = `csv-label`,
  cssInputClass = `csv-input`,
  fileEncoding = `UTF8`,
  inputId = null,
  inputStyle = {},
  label,
  onError,
  onFileLoaded,
  parserOptions = {},
  disabled = true,
}) {
  const handleChangeFile = async (e) => {
    if (e.target.files.length > 0) {
      const filename = e.target.files[0].name
      const reader = new FileReader()
      reader.onload = (event) => {
        const data = event.target.result
        const codes = new Uint8Array(data)
        const encoding = Encoding.detect(codes)
        console.log(encoding)
        const unicodeString = Encoding.convert(codes, {
          type: `string`,
          from: encoding,
          to: `unicode`,
        })
        console.log(unicodeString)
        const csvData = Papa.parse(unicodeString,
          {
            header: true,
            dynamicTyping: false, // trueにすると、文字列の数は、数値に変換される
            skipEmptyLines: true,
            // quotes: false,
            // quoteChar: `"`,
            // delimiter: `,`,
            // escapeChar: `,`,
            error: onError,
          })
        console.log(csvData)
        return onFileLoaded(csvData.data)
      }
      reader.readAsArrayBuffer(e.target.files[0])
    }
  }

  return (
    <div className={cssClass}>
      {label && <label className={cssLabelClass} htmlFor={inputId}>{label}</label>}
      <input
        disabled={disabled}
        className={cssInputClass}
        type="file"
        id={inputId}
        style={inputStyle}
        accept={accept}
        onChange={(e) => handleChangeFile(e)}
      />
    </div>
  )
}
